import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { MarketerProfileDetails } from "../../Interfaces/ResponsesData";
import { SalaryItems } from "../../Models/Marketer";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { max } from "date-fns";
import { AxiosRequest } from "../../Handlers/AxiosHandler";


export class MarketerDetailsVM extends InterActive{
    private id:string = ''
    private data?:MarketerProfileDetails
    private salaryData:SalaryItems ={id:'', sales:0 , commission:0 , deserved:0 , genTarget:0 , target:'0' , genCuts:0 , cut:'0' , genBounses:0 , bounus:'0' ,finalSalary:0 , notes:'' }
    
    public get Id():string{ return this.id}
    public get Data():MarketerProfileDetails|undefined { return this.data }
    public get SalaryData():SalaryItems{ return this.salaryData }

    public set Target(value:string) { this.salaryData.target = value; this.calFinal(); this.update() }
    public set Cuts(value:string) { this.salaryData.cut = value; this.calFinal(); this.update() }
    public set Bounses(value:string) { this.salaryData.bounus = value; this.calFinal(); this.update() }
    public set Notes(value:string) { this.salaryData.notes = value; this.update() }


    constructor(id:string){
        super()
        this.id = id
    }

    public getCards(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getMarketerFinance(this.id)
                    console.log(response)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = response.data.data
                                console.log(response.data)
                                this.filldata()
                                this.update()
                            }else Notify({type:"danger" , title:'فشل العملية' , body:response.data.messege})
                        }else Notify({type:"danger" , title:'فشل العملية' , body:'مشكلة غير معروفة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:"danger" , title:'فشل العملية' , body:'مشكلة غير معروفة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    private filldata(){
        if(this.data){
            this.salaryData.id = this.id
            this.salaryData.sales = this.getTotalSales()
            this.salaryData.commission = this.data.commission 
            this.salaryData.deserved = Math.ceil(Number(this.salaryData.sales)*Number(this.salaryData.commission)*100)/10000 
            this.salaryData.genTarget = this.data.target
            this.salaryData.genCuts = this.data.cuts
            this.salaryData.genBounses = this.data.bonuses
            this.calFinal()
        }

    }

    private calFinal(){
        this.salaryData.finalSalary = Number(this.salaryData.deserved) + Number(this.salaryData.genTarget) + Number(this.salaryData.target) + Number(this.salaryData.genBounses) + Number(this.salaryData.bounus) - Number(this.salaryData.genCuts) - Number(this.salaryData.cut)
    }

    private getTotalSales(){
        var sum = 0
        this.data?.cards.forEach(a=>{
            sum = sum + (Number(a.waiting_sales)*Number(a.price))
        })
        return Math.ceil(sum*100)/100
    }

    public send(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.confirmSalary(this.salaryData)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                Notify({type:'success' , title:'تمت العملية بنجاح' , body:'تم اعتماد الراتب بنجاح'})
                                this.salaryData = {id:'', sales:0 , commission:0 , deserved:0 , genTarget:this.salaryData.genTarget , target:'0' , genCuts:this.salaryData.genCuts, cut:'0' , genBounses:this.salaryData.genBounses , bounus:'0' ,finalSalary:0 , notes:'' }
                                this.getCards()
                            }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }

    public changeState(status:'active'|'inActive'){
        this.loading(async()=>{
            let response = await AxiosRequest.statusPost<{id:string, status:'active'|'inActive'}>('changeMarketerState',{id:this.id , status:status})
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        if(this.data)this.data.status = status
                        this.update()
                    }
                }
            }
        })
    }
}